import { combineReducers } from "redux";

import { divingCourseDetails } from "./reducer.divingcourse"
const divingCourseReducers = combineReducers({

  divingCourseDetails

})
export default divingCourseReducers;
